// Out-Play.in brand constants
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_sports-academy-demo/artifacts/ufblb3de_logo%20new.jpg";
export const BRAND_NAME = "Out-Play";
export const BRAND_TAGLINE = "India's #1 Sports Academy SaaS";

// Brand logo text component helper - use in JSX: <BrandText />
// Returns: OUT (dark) + -Play (red)
export function BrandText({ className = '' }) {
  return (
    <span className={`font-display font-bold ${className}`}>
      <span className="text-foreground">Out</span>
      <span className="text-red-500">-Play</span>
    </span>
  );
}

// ─────────────────────────────────────────────────────────────────────
// StreamX sub-brand — Phase StreamX Rebrand Sprint 1.
//
// Single source of truth for the StreamX rebrand (formerly LiveX).  Use
// these constants in ANY user-visible string so future identity changes
// never require code archaeology.
//
// IMPORTANT — what does NOT change:
//   • DB collections (livex_subscriptions, livex_invoices, …)
//   • API paths (/api/livex/*)
//   • Internal variable / file / component names
//   • Existing /livex/* routes (dual-mounted with /streamx/*)
// ─────────────────────────────────────────────────────────────────────

export const STREAMX_BRAND = 'StreamX';
export const STREAMX_TAGLINE = 'Sports Broadcasting by Out-Play';
export const STREAMX_FULL = 'StreamX by Out-Play';

// Pricing plan names — every billing surface MUST reference these.
export const STREAMX_PLAN_PRO = 'StreamX Pro';
export const STREAMX_PLAN_PRO_DESC = 'StreamX Pro Subscription';

// Legacy aliases — used ONLY when a string MUST refer to the old brand.
export const STREAMX_LEGACY_BRAND = 'LiveX';

// Route prefixes — `/streamx` is the canonical, `/livex` survives for
// backward-compat (dual-mounted in App.js).
export const STREAMX_CANONICAL_PATH = '/streamx';
export const STREAMX_LEGACY_PATH = '/livex';

/**
 * Helper — produce a canonical URL for a given StreamX subpath.
 * @example streamxUrl('/watch/abc') → 'https://out-play.in/streamx/watch/abc'
 */
export function streamxUrl(subpath = '') {
  const clean = subpath.startsWith('/') ? subpath : `/${subpath}`;
  const host = (typeof window !== 'undefined' && window.location?.host) || 'out-play.in';
  return `https://${host}${STREAMX_CANONICAL_PATH}${clean}`;
}

/**
 * Helper — produce a copy line that includes the parent brand.
 * @example streamxLine() → 'StreamX by Out-Play'
 *          streamxLine('Pro') → 'StreamX Pro by Out-Play'
 */
export function streamxLine(suffix = '') {
  return suffix ? `${STREAMX_BRAND} ${suffix} by ${BRAND_NAME}` : STREAMX_FULL;
}
